export default __webpack_public_path__ + "static/media/DtVjJx26TKEr37c9aBtJn3YO5gjupg.0310ed77.woff2";